module.exports = __webpack_public_path__ + "static/media/icon_notificacion.cd321770.svg";